/** Chuỗi hiển thị của trang "Lịch phát thanh" (soạn lịch theo ngày, khung giờ, bản tin). */
export const viLichPhatThanh = {
  tieuDe: 'Lịch phát',
  tieuDeSua: 'Chỉnh sửa lịch phát',
  dangTaiLich: 'Đang tải lịch phát…',
  loiTaiLich: 'Không tải được lịch phát: {loi}',
  daCapNhat: 'Đã cập nhật lịch phát "{ten}".',
  quayLai: 'Quay lại',
  xemLichDaLap: 'Xem lịch đã lập',
  tenLich: 'Tên lịch phát',
  diaBan: 'Chọn địa bàn',
  diaBanTatCa: 'Toàn tỉnh',
  thietBi: 'Chọn thiết bị ({so} thiết bị)',
  tatCaThietBi: 'Chọn tất cả thiết bị',
  timThietBi: 'Tìm thiết bị theo tên hoặc mã…',
  boChon: 'Bỏ chọn',
  dangTaiThietBi: 'Đang tải thiết bị…',
  khongCoThietBi: 'Không có thiết bị phù hợp',
  hienThiToiDa: 'Hiển thị {so} thiết bị đầu tiên — gõ để tìm thêm',
  dsNgay: 'Danh sách ngày phát ({so} ngày',
  themNgay: 'Thêm ngày phát',
  saoChep: 'Sao chép',
  xoa: 'Xóa',
  themKhung: 'Thêm mới khung giờ',
  cot: { ten: 'Tên khung giờ', batDau: 'Bắt đầu', ketThuc: 'Kết thúc', noiDung: 'Nội dung phát' },
  soBanTin: '{so} bản tin',
  xoaKhung: 'Xóa khung giờ',
  ketThucTay: 'Có bản tin chưa rõ thời lượng — nhập giờ kết thúc',
  luu: 'Lưu lịch phát',
  dangLuu: 'Đang lưu…',
  huy: 'Hủy',
  daLuu: 'Đã lưu {so} lịch phát.',
  loiLuu: 'Không lưu được lịch phát: {loi}',
  daLuuMot: 'Đã lưu {so}/{tong} lịch trước khi gặp lỗi.',
  canTen: 'Cần nhập tên lịch phát',
  canDiaBan: 'Cần chọn địa bàn',
  lich: {
    tieuDe: 'Chọn ngày',
    tieuDeSaoChep: 'Sao chép khung giờ của ngày {ngay} sang',
    thang: 'Tháng {thang}, {nam}',
    thangTruoc: 'Tháng trước',
    thangSau: 'Tháng sau',
    thu: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
    huy: 'Hủy',
    xacNhan: 'Xác nhận',
    dong: 'Đóng',
  },
  chonBanTin: {
    tieuDe: 'Chọn bản tin phát — {khung}',
    tim: 'Tìm bản tin…',
    cot: {
      chon: 'Chọn',
      thuTu: 'Thứ tự',
      tieuDe: 'Tiêu đề',
      thoiLuong: 'Thời lượng',
      linhVuc: 'Lĩnh vực',
      uuTien: 'Mức độ ưu tiên',
    },
    dangTai: 'Đang tải bản tin đã duyệt…',
    rong: 'Chưa có bản tin đã duyệt.',
    tong: 'Đã chọn {so} bản tin, tổng thời lượng {tl}',
    chuaRo: 'chưa rõ',
    xacNhan: 'Xác nhận',
    huy: 'Hủy',
  },
  loi: {
    chuaCoNgay: 'Chưa có ngày phát nào',
    ngayChuaCoKhung: 'Ngày {ngay} chưa có khung giờ',
    chuaChonBanTin: '{khung}: chưa chọn bản tin',
    thieuThoiLuong: '{khung}: bản tin chưa có thời lượng, nhập giờ kết thúc',
    ketThucTruoc: '{khung}: giờ kết thúc phải sau giờ bắt đầu',
    qua24: '{khung}: vượt quá 24:00:00',
    quaKhu: '{khung}: đã ở trong quá khứ',
    trung: '{khung}: trùng thời gian với {khac}',
  },
  tenKhung: 'Khung giờ {bd} - {kt}',
};
